import React from 'react';
import { useMMSelector, useMMDispatch } from '../../../_hocs/withOwnReduxStore';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import { getPostStreamIdFromMediaSource } from '../../../helpers';
import { fetchMorePosts } from '../../../actions';
import { getDeviationsByIds } from '../../../../redux/deviations/selectors';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { selectors } from '../../../../Stream';
import DeviationSelector from '../';
import { useCurrentMediaSource } from '../../../_hocs/withCurrentMediaSource';

export type Props = {};

const PostDeviationSelector: React.FC<Props> = () => {
  const dispatch = useMMDispatch();
  const { currentMediaSource } = useCurrentMediaSource();
  const streamId = getPostStreamIdFromMediaSource(currentMediaSource);

  const deviations = useMMSelector(state =>
    getDeviationsByIds(state, selectors.getItems(state, streamId))
  );
  const isFetching = useMMSelector(state => selectors.isFetching(state, streamId));
  const hasMore = useMMSelector(state => selectors.hasMore(state, streamId));
  const isInitialized = useMMSelector(state => selectors.isInitialized(state, streamId));

  const fetchMoreIfNeeded = () => {
    if (!hasMore || isFetching) {
      return;
    }
    dispatch(fetchMorePosts());
  };

  const renderContent = () => {
    return (
      <>
        {isInitialized && deviations.length > 0 && <DeviationSelector deviations={deviations} />}
        {(!isInitialized || isFetching) && (
          <LoadingIndicator view="daSymbol" coverMode={!hasMore} />
        )}
      </>
    );
  };

  return (
    <PopupInnerLayout
      headerExtrasBottomZone={<SelectedItemsPanel />}
      scrollableContent={renderContent()}
      onScrolledToBottom={fetchMoreIfNeeded}
      onNotScrollable={fetchMoreIfNeeded}
    />
  );
};

export default PostDeviationSelector;
